import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import TodoItem from './TodoItem'
import { Todo } from '../lib/supabase'
import { GripVertical } from 'lucide-react'

interface SortableTodoItemProps {
  todo: Todo
  onTriggerCelebration?: (x: number, y: number) => void
}

export default function SortableTodoItem({ todo, onTriggerCelebration }: SortableTodoItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: todo.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="group/sortable mb-1 sm:mb-1.5"
    >
      <div className="flex items-stretch rounded-lg shadow-md">
        <button
          className={`w-5 sm:w-8 flex-shrink-0 flex items-center justify-center cursor-grab active:cursor-grabbing opacity-100 sm:opacity-40 sm:group-hover/sortable:opacity-100 transition-opacity drag-handle rounded-l-lg border border-r-0 ${
            todo.project?.is_team_project
              ? 'bg-gray-800 border-gray-700'
              : 'bg-gray-100 border-gray-300'
          }`}
          {...attributes}
          {...listeners}
          style={{
            WebkitTouchCallout: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            msUserSelect: 'none',
            MozUserSelect: 'none'
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <GripVertical className={`h-4 w-4 sm:h-5 sm:w-5 ${
            todo.project?.is_team_project ? 'text-white' : 'text-gray-500'
          }`} />
        </button>
        <div className="flex-1 min-w-0">
          <TodoItem todo={todo} onTriggerCelebration={onTriggerCelebration} />
        </div>
      </div>
    </div>
  )
}